/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Failed_Download_FileInputs */



/**
* | output |
* | --- |
* | "Failed to download file" |
*
* @param {Spaces_Toast_Failed_Download_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_failed_download_file = /** @type {((inputs?: Spaces_Toast_Failed_Download_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Failed_Download_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Herunterladen der Datei fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Failed to download file")
});